import 'babel-polyfill'

import './accordion'
import './animate-on-scroll'
import './button-icon'
import './carousel'
import './carousel-original-chain'
import './carousel-timeline'
import './check-for-touch'
import './contact-form'
// import './cookie-bar'
import './drawer'
import './drawer-menu'
import './farmer'
import './font-loader'
import './front-page'
import './four-oh-four'
import './hero-image'
import './hero-with-link'
import './local-video'
import './page-stagger'
import './paper-tear-image'
import './print-button'
import './product-intro'
import './product-stores'
import './product-timeline'
import './scroll-link'
import './shapes-bg'
import './single-product'
import './single-recipe'
import './post-rating'
import './site-header'
import './tag-nav'
import './term-nav'
import './title'
import './pinterest-button'
import './video-youtube'
import './custom-anchorpoints'
import './lib/lazyload'
import './strl-scripts'
// import './cat_filter_ajax'
